// extracted by mini-css-extract-plugin
module.exports = {"header":"PartnerHeader_header_3qBDz","logo":"PartnerHeader_logo_GKj7m","lang":"PartnerHeader_lang_FGmzw","expand":"PartnerHeader_expand_1-mp2","flag":"PartnerHeader_flag_1DJOe"};